/** @format */

import React from 'react'
import styled from 'styled-components'
import { Controlled } from 'react-codemirror2'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/material.css'
import 'codemirror/mode/yaml/yaml'

interface YamlCodemirrorProps {
  className?: string
  value: string
  onChange?: (value: string) => void
}
const YamlCodemirror: React.FC<YamlCodemirrorProps> = ({ className, value = '', onChange }) => {
  return (
    <Controlled
      className={className}
      value={value}
      options={{
        mode: 'yaml',
        theme: 'material',
        lineNumbers: true,
        lineWrapping: true,
        foldGutter: true,
        gutters: ['CodeMirror-linenumbers'],
        // 快捷键配置
        extraKeys: {
          Tab: 'indentMore', // Tab 增加缩进
          'Shift-Tab': 'indentLess', // Shift+Tab 减少缩进
          Enter: 'newlineAndIndent' // Enter 换行并缩进
        }
      }}
      onBeforeChange={(editor, data, value) => {
        onChange?.(value)
      }}
    />
  )
}

export default styled(YamlCodemirror)`
  .CodeMirror {
    height: 500px;
  }
`
